// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__MK4XP","progress":"styles_progress__62NKy","text":"styles_text__Y7w2V"};